import parseISO from 'date-fns/parseISO'

import useLocale from '~/hooks/useLocale'
import { DATE_TIME_FORMAT } from '~/shared/constants/time.const'
import { formatInterval, getTimezoneOffset } from '~/utils/time'
import { getBrowserTimezone } from '~/utils/helpers'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import TimezoneIcon from '~/components/Icons/svgs/TimezoneIcon'

const { DAY_MONTH_WEEKDAY_YEAR } = DATE_TIME_FORMAT

export default function SessionTimeInfo({
  endTime,
  startTime,
}: {
  endTime: string
  startTime: string
}): React.ReactElement {
  const locale = useLocale()
  const dateStr = new Date(startTime).toLocaleDateString(locale, DAY_MONTH_WEEKDAY_YEAR)

  const timezone = getBrowserTimezone()
  const timezoneOffset = getTimezoneOffset(timezone)

  return (
    <span>
      <span className="flex">{dateStr}</span>
      <span className="flex space-x-1">
        <span>{formatInterval(parseISO(startTime), parseISO(endTime))}</span>
        <span>&sdot;</span>
        <span className="space-x-0.5 flex items-center text-2.5 text-gray-ash">
          <SVGIcon icon={TimezoneIcon} pathClassName="currentColor" size={14} />
          <span>{timezoneOffset}</span>
        </span>
      </span>
    </span>
  )
}
